<zwi-widget>
  <form [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field appearance="fill" class="zwi-form-field--medium">
      <mat-label>Series name</mat-label>
      <input formControlName="series" matInput>
      @if (form.get('series')?.hasError('required')) {
        <mat-error>Please enter a name</mat-error>
      }
    </mat-form-field>
    <button mat-raised-button color="primary" style="margin-left: 8px;">Add</button>
  </form>
  <div class="mat-subtitle-2">Series</div>
  <mat-list>
    @for (series of series; track series) {
      <mat-list-item>
        <mat-icon matListItemIcon>list_alt</mat-icon>
        <span matListItemTitle>{{ series.name }}</span>
      </mat-list-item>
    }
  </mat-list>
</zwi-widget>
